import React from 'react';
import { Box, styled, Container, Typography } from '@mui/material';
import bgImg from '../../assets/img/services-bg.webp';
import { useTranslation } from 'react-i18next';

const DivBackground = styled('div')(() => ({
  maxWidth: '100%',
  minHeight: '100vh',
  background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.4)), url(${bgImg}) center center no-repeat`,
  backgroundSize: 'cover',
  backgroundAttachment: 'fixed',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background:
      'linear-gradient(135deg, rgba(168, 85, 144, 0.2) 0%, rgba(0, 0, 0, 0.3) 100%)',
    zIndex: 1,
  },
}));

const ContentBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  zIndex: 2,
  textAlign: 'left',
  padding: theme.spacing(8, 0),
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
    padding: theme.spacing(6, 0),
  },
}));

const StyledTitle = styled(Typography)(({ theme }) => ({
  color: '#292929', // The burgundy/pink color from "Our Services"
  fontWeight: 700,
  fontSize: '3.5rem',
  lineHeight: 1.2,
  marginBottom: theme.spacing(3),
  textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
  fontFamily: '"Playfair Display", "Georgia", serif',
  [theme.breakpoints.down('lg')]: {
    fontSize: '3rem',
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '2.5rem',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '2rem',
  },
}));

const StyledSubtitle = styled(Typography)(({ theme }) => ({
  color: '#ffffff',
  fontWeight: 400,
  fontSize: '1.25rem',
  lineHeight: 1.6,
  maxWidth: '800px',
  textShadow: '1px 1px 3px rgba(0, 0, 0, 0.7)',
  backgroundColor: 'rgba(0, 0, 0, 0.3)',
  padding: theme.spacing(3),
  borderRadius: theme.spacing(1),
  backdropFilter: 'blur(5px)',
  border: '1px solid rgba(255, 255, 255, 0.1)',
  [theme.breakpoints.down('md')]: {
    fontSize: '1.125rem',
    padding: theme.spacing(2.5),
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '1rem',
    padding: theme.spacing(2),
  },
}));

const Intro = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <DivBackground>
        <Container maxWidth="lg">
          <ContentBox>
            <StyledTitle variant="h1" as="h1">
              {t('services.intro.title')}
            </StyledTitle>
            <StyledSubtitle variant="h6" as="p">
              {t('services.intro.subtitle')}
            </StyledSubtitle>
          </ContentBox>
        </Container>
      </DivBackground>
    </Box>
  );
};

export default Intro;
